export default __webpack_public_path__ + "78626ecd9c700463080cd2e3e1ddbe7d.png";